import React from 'react'

const SelectInputPagination = ({
    onChange,
    labelName,
    options,
    defaultValue = 10,
    disabled
}) => {

    return (
        <div className="" style={{ minWidth: '50px' }}>
            <div>
                <select
                    style={{
                        // border: '2px solid rgba(107, 107, 107, 0.12)',
                        padding: '11px 5px',
                    }}
                    // className="custom-select join-as-style cursor-pointer"
                    className="custom-select rounded-2 cursor-pointer "

                    onChange={onChange}
                    defaultValue={defaultValue}
                    disabled={disabled}
                >
                    <option value={''} disabled>Page size</option>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                </select>
            </div>
        </div>
    )
}

export default SelectInputPagination;